// extracted by mini-css-extract-plugin
export default {"bnplPaymentMethodWrapper":"bnplPaymentMethodWrapper__91j5M","title":"title__ElVJ8","theBnplBancolombiaLogo":"theBnplBancolombiaLogo__NiMdr"};